<template>
  <v-row class="mb-1 mt-1">
    <v-col cols="12">
      <v-card
        class="px-4 py-3"
        variant="flat">
        <v-row
          align="center"
          no-gutters>
          <v-col>
            <span class="text-h3 text-secondary">{{ props.title }}</span>
          </v-col>
          <v-spacer></v-spacer>
          <DateSelector v-if="props.showDateSelector" />
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import DateSelector from '@/components/DateSelector.vue';

const props = defineProps({
  title: String,
  showDateSelector: Boolean
});
</script>
